import {makeAutoObservable} from "mobx";
import history from '../authentication/History';
import {toast} from 'react-toastify';
import environment from '../environments';
import {apiFetch, notifyError} from '../api';

const emptyProduct = () => ({stickerList: []});

class ProductStore
{

    productList = [];
    inputs = [];
    blankpageParts = [];
    product = emptyProduct();
    /* ID of the record in product, so a different record never shows stale data */
    loadedId = null;
    start = 0;
    limit = 100;

    maxInputs = 20;
    layoutOptions = [];
    sppInput = [...Array(this.maxInputs + 1).keys()].slice(1);
    fileToUpload = {};
    appIconFile = {};
    lpIconFile = {};
    bannerFile = {};
    videoFile = {};
    templateFile = {};
    uploading = false;

    searchTerm = "";

    /* Endpoints */
    detailRoute = "/products";
    dataEndpoint = environment.API_HOST + "/products/list";
    searchEndpoint = environment.API_HOST + "/products/search";

    /* Table configuration */
    sortBy = "productid";
    sortOrder = "asc";
    tableColumns = [
        //{name: "#", field: "id", type: "text"},
        {name: "Produktnummer", field: "productid", type: "text", sortable: true},
        {name: "Name", field: "name", type: "text", sortable: true},
        {name: "Sticker pro Seite", field: "stickers_per_page", type: "text", sortable: true},
        {name: "Sticker (Produziert)", field: "stickercount", type: "text", sortable: true},
        {name: "Sticker (Aktiviert)", field: "activestickers", sortable: true},
        {name: "Icon", field: "icon_key", type: "image", sortable: false}
    ]

    constructor()
    {
        makeAutoObservable(this)
    }

    getProductList()
    {
        apiFetch(this.dataEndpoint + "?start=" + this.start + "&limit=" + this.limit + "&sortBy=" + this.sortBy + "&sortOrder=" + this.sortOrder)
            .then((json) =>
            {
                this.productList = json.data
            })
            .catch((error) =>
            {
                notifyError(error);
                return error;
            })
    }

    searchProduct()
    {
        /* Start again on the first page */
        this.start = 0;

        if (this.searchTerm && this.searchTerm.length > 0)
        {
            const term = this.searchTerm;
            apiFetch(this.searchEndpoint + "?term=" + encodeURIComponent(term))
                .then((json) =>
                {
                    if (term === this.searchTerm)
                    {
                        this.productList = json.data
                    }
                })
                .catch((error) =>
                {
                    notifyError(error);
                })

        } else
        {
            this.getProductList();
        }
    }

    addProduct()
    {
        apiFetch(environment.API_HOST + "/products/new", {
            method: 'POST',
        })
            .then((json) =>
            {
                history.push('/products/' + json.data.id)
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    duplicateProduct(id)
    {
        apiFetch(environment.API_HOST + "/products/" + id + "/duplicate", {
            method: 'POST',
        })
            .then((json) =>
            {
                toast.success("Produkt erfolgreich dupliziert");
                /* Open the copy right away */
                history.push('/products/' + json.data.id);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    getProduct(id)
    {
        if (this.loadedId !== id)
        {
            this.product = emptyProduct();
            this.loadedId = id;
        }

        apiFetch(environment.API_HOST + "/products/" + id)
            .then((json) =>
            {
                /* Ignore responses for a record that is no longer open */
                if (id !== this.loadedId)
                {
                    return;
                }

                this.product = json.data[0]
                this.layoutOptions = [...Array(this.product.stickers_per_page + 1).keys()].slice(1)
                this.product.layout = JSON.parse(this.product.layout);

                if (this.product.layout)
                {
                    if (this.product.layout.length !== this.product.stickers_per_page)
                    {
                        this.product.layout = [...Array(this.product.stickers_per_page + 1).keys()].slice(1)
                    }
                } else
                {
                    this.product.layout = [...Array(this.product.stickers_per_page + 1).keys()].slice(1)
                }
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    saveProduct(id)
    {
        var payload = {
            name: this.product.name,
            linkable: this.product.linkable,
            stickers_per_page: this.product.stickers_per_page,
            landingpage: this.product.landingpage,
            landingpage_intro: this.product.landingpage_intro,
            location: this.product.location,
            trackable: this.product.trackable,
            foreground_color: this.product.foreground_color,
            background_color: this.product.background_color,
            button_color: this.product.button_color,
            button_text: this.product.button_text,
            button_text_color: this.product.button_text_color,
            label_color: this.product.label_color,
            delimiter_color: this.product.delimiter_color,
            print_identifier: this.product.print_identifier,
            identifier_color: this.product.identifier_color,
            print_logo: this.product.print_logo,
            logo_color: this.product.logo_color,
            qrcode_color: this.product.qrcode_color,
            show_ads: this.product.show_ads,
            shop_url: this.product.shop_url,
            shop_url_visible: this.product.shop_url_visible,
            shop_url_landingpage_visible: this.product.shop_url_landingpage_visible,
            help_url: this.product.help_url,
            help_url_visible: this.product.help_url_visible,
            redirect_description: this.product.redirect_description,
            blankpage_layout: this.product.blankpage_layout,
            layout: JSON.stringify(this.product.layout)
        }
        payload = JSON.stringify(payload);

        apiFetch(environment.API_HOST + "/products/" + id, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json"
            },
            body: payload
        })
            .then((json) =>
            {
                toast.success("Produkt erfolgreich gespeichert.");
                this.getProduct(id);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    upload(id, type)
    {
        var formData = new FormData();
        var fileToUpload;

        switch (type)
        {
            case 'icon':
                type = "icon";
                fileToUpload = this.lpIconFile
                break;
            case 'template':
                type = "template";
                fileToUpload = this.templateFile
                break;
            case 'video':
                type = "video";
                fileToUpload = this.videoFile
                break;
            case 'banner':
                type = "banner";
                fileToUpload = this.bannerFile
                break;
            default:
                break;
        }

        formData.append('file', fileToUpload);
        this.uploading = true;
        apiFetch(environment.API_HOST + "/products/" + id + "/" + type, {
            method: 'POST',
            body: formData
        })
            .then((json) =>
            {
                toast.success("Upload erfolgreich.");
                this.getProduct(id);
                this.uploading = false;
            })
            .catch((error) =>
            {
                notifyError(error);
                this.uploading = false;
            })

    }

    deleteProduct(id)
    {
        apiFetch(environment.API_HOST + "/products/" + id, {
            method: 'DELETE',
        })
            .then((json) =>
            {
                history.push('/products')
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    getInputList(id)
    {
        apiFetch(environment.API_HOST + "/products/" + id + "/landingpage/list")
            .then((json) =>
            {
                this.inputs = json.data
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    addInput(id)
    {
        apiFetch(environment.API_HOST + "/products/" + id + "/landingpage/new", {
            method: 'POST',
        })
            .then((json) =>
            {
                this.getInputList(id);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    saveInput(productid, index)
    {
        var payload = {
            type: this.inputs[index].type,
            label: this.inputs[index].label,
            placeholder: this.inputs[index].placeholder,
            information: this.inputs[index].information,
            options: this.inputs[index].options,
            visible: +this.inputs[index].visible,
            show_label: +this.inputs[index].show_label,
            displayorder: this.inputs[index].displayorder,
            bold: +this.inputs[index].bold,
            centered: +this.inputs[index].centered,
            html_element: this.inputs[index].html_element,
            delimiter: +this.inputs[index].delimiter,
            text_color: this.inputs[index].text_color,
        }

        payload = JSON.stringify(payload);

        apiFetch(environment.API_HOST + "/products/" + productid + "/landingpage/" + this.inputs[index].uuid, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json"
            },
            body: payload
        })
            .then((json) =>
            {
                toast.success("Eingabefeld erfolgreich gespeichert.");
                this.getInputList(productid);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    deleteInput(productid, inputuuid)
    {
        apiFetch(environment.API_HOST + "/products/" + productid + "/landingpage/" + inputuuid, {
            method: 'DELETE',
        })
            .then((json) =>
            {
                this.getInputList(productid);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    getBlankpageParts(id)
    {
        apiFetch(environment.API_HOST + "/products/" + id + "/blankpage/list")
            .then((json) =>
            {
                this.blankpageParts = json.data
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    addBlankpagePart(id)
    {
        apiFetch(environment.API_HOST + "/products/" + id + "/blankpage/new", {
            method: 'POST',
        })
            .then((json) =>
            {
                this.getBlankpageParts(id);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    saveBlankpagePart(productid, index)
    {
        var payload = {
            type: this.blankpageParts[index].type,
            content: this.blankpageParts[index].content,
            destination: this.blankpageParts[index].destination,
            displayorder: this.blankpageParts[index].displayorder,
        }

        payload = JSON.stringify(payload);

        apiFetch(environment.API_HOST + "/products/" + productid + "/blankpage/" + this.blankpageParts[index].uuid, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json"
            },
            body: payload
        })
            .then((json) =>
            {
                toast.success("Abschnitt erfolgreich gespeichert.");
                this.getBlankpageParts(productid);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    deleteBlankpagePart(productid, pagepartuuid)
    {
        apiFetch(environment.API_HOST + "/products/" + productid + "/blankpage/" + pagepartuuid, {
            method: 'DELETE',
        })
            .then((json) =>
            {
                this.getBlankpageParts(productid);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    resetBlankpageParts(id)
    {
        apiFetch(environment.API_HOST + "/products/" + id + "/blankpage/reset", {
            method: 'POST',
        })
            .then((json) =>
            {
                toast.success("Blankoseite erfolgreich zurückgesetzt.");
                this.getBlankpageParts(id);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    sort(column)
    {
        /* Start again on the first page */
        this.start = 0;

        this.sortBy = column;

        if (this.sortOrder === 'asc')
        {
            this.sortOrder = 'desc';
        } else
        {
            this.sortOrder = 'asc';
        }

        this.getProductList();
    }

    nextPage()
    {
        this.start = this.start + this.limit
        this.getProductList();
    }

    previousPage()
    {
        if (this.start - this.limit >= 0)
        {
            this.start = this.start - this.limit
            this.getProductList();
        }
    }
}

const productStore = new ProductStore();
export default productStore;
